import { render, staticRenderFns } from "./StatsAccountUserBox.vue?vue&type=template&id=173885c4&scoped=true&"
import script from "./StatsAccountUserBox.vue?vue&type=script&lang=js&"
export * from "./StatsAccountUserBox.vue?vue&type=script&lang=js&"
import style0 from "./StatsAccountUserBox.vue?vue&type=style&index=0&id=173885c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173885c4",
  null
  
)

export default component.exports